var map = {
	"./beach_bg.svg": 994,
	"./best-deals-bg.svg": 1340,
	"./close-dark.svg": 1341,
	"./close.svg": 663,
	"./compare.svg": 1342,
	"./day_night.svg": 995,
	"./favorite.svg": 1343,
	"./guide.svg": 947,
	"./house.svg": 1344,
	"./info-icon.svg": 996,
	"./info-outline.svg": 997,
	"./info.svg": 1345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1339;